import { defineMessages } from 'react-intl';

export default defineMessages({
    startQuote: {
        id: 'quoteandbind.directives.ProductZipCodeContainer.Start Quote',
        defaultMessage: 'Get Quote',
    },
    retrieveQuote: {
        id: 'quoteandbind.directives.ProductZipCodeContainer.Retrieve Quote',
        defaultMessage: 'Retrieve your saved quote',
    },
    zipCodePlaceholder: {
        id: 'quoteandbind.directives.Enter ZIP Code',
        defaultMessage: 'Enter ZIP Code',
    },
    zipCodeLabel: {
        id: 'quoteandbind.directives.ZIP Code',
        defaultMessage: 'ZIP Code',
    },
});
